var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "other-contents" },
        [
          _c("div", { on: { click: _vm.openModal } }, [
            _c("img", {
              staticClass: "account-information",
              attrs: {
                src: require("@/assets/other/アセット 10@2x.png"),
                width: "2100",
                height: "360",
                loding: "lazy"
              }
            })
          ]),
          _vm._v(" "),
          _vm.hearingsAlert
            ? _c("div", [
                _c("img", {
                  staticClass: "health-check",
                  class: { zindex: _vm.isTutorial },
                  attrs: {
                    src: require("@/assets/other/アセット 11@2x.png"),
                    width: "2100",
                    height: "360",
                    loding: "lazy"
                  },
                  on: { click: _vm.openDialog }
                })
              ])
            : _c(
                "div",
                [
                  _c("router-link", { attrs: { to: "frailtyRiskCheck" } }, [
                    _c("img", {
                      staticClass: "health-check",
                      class: { zindex: _vm.isTutorial },
                      attrs: {
                        src: require("@/assets/other/アセット 11@2x.png"),
                        width: "2100",
                        height: "360",
                        loding: "lazy"
                      }
                    })
                  ])
                ],
                1
              ),
          _vm._v(" "),
          _c("div", { on: { click: _vm.openModal } }, [
            _c("img", {
              staticClass: "healthcare-services",
              attrs: {
                src: require("@/assets/other/アセット 12@2x.png"),
                width: "2100",
                height: "360",
                loding: "lazy"
              }
            })
          ]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: "/top" } }, [
            _c("img", {
              staticClass: "logout",
              attrs: {
                src: require("@/assets/other/アセット 13@2x.png"),
                width: "2100",
                height: "360",
                loding: "lazy"
              }
            })
          ]),
          _vm._v(" "),
          _c("div")
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.isTutorial ? _c("Tutorial") : _vm._e(),
      _vm._v(" "),
      _c("ShowDialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isDialog,
            expression: "isDialog"
          }
        ],
        on: { "handle-hide-dialog": _vm.hideDialog }
      }),
      _vm._v(" "),
      _vm.isShowContent
        ? _c("ShowContent", { on: { "handle-hide-content": _vm.closeModal } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07efdf1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07efdf1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Other.vue
// module id = null
// module chunks = 